import React from "react";
import { Alert } from "@themesberg/react-bootstrap";

export default function BankDetailForm({
  customUserId,
  ownerCustomUserId,
  initialData,
}) {
  const hasOwnerBank = !!initialData?.account_number;

  return (
    <div>
      <h6 className="mb-3 fw-bold">Bank Details for {customUserId}</h6>

      <Alert variant="info" className="py-3">
        This Sub-ID uses the main user&apos;s bank account for payouts.
        {ownerCustomUserId ? (
          <> Payouts are sent to the primary account ({ownerCustomUserId}).</>
        ) : null}
      </Alert>

      {hasOwnerBank ? (
        <div className="bg-light rounded p-3">
          <div className="d-flex justify-content-between py-1">
            <span className="text-muted">Account Holder</span>
            <span className="fw-semibold">{initialData.account_holder_name || "—"}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span className="text-muted">Bank</span>
            <span className="fw-semibold">{initialData.bank_name || "—"}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span className="text-muted">Account Number</span>
            <span className="fw-semibold">{initialData.account_number || "—"}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span className="text-muted">IFSC</span>
            <span className="fw-semibold">{initialData.ifsc_code || "—"}</span>
          </div>
        </div>
      ) : (
        <Alert variant="warning" className="mb-0 py-2">
          Main user bank details are not saved yet. Add bank details on your primary profile
          before Sub-ID payouts can be processed.
        </Alert>
      )}
    </div>
  );
}
